import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function SuccessStories() {
  return <ComingSoon title="Client Success Stories" />;
}
